
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a712463265 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1787980257 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1131350675 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b2128480230 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1004345579 = pluralGeneratorFn(function(n
) {
  return (n >= 0 && n < 2) ? 'one' : 'other';
});
Globalize.b1916443906 = messageFormatterFn((function(  ) {
  return function(d) { return "Voyages : vacances, vols pas chers, billets d’avion et prix des billets"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b857214662 = messageFormatterFn((function(  ) {
  return function(d) { return "Points appliqués"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1779864483 = messageFormatterFn((function(  ) {
  return function(d) { return "Aucun point ne sera appliqué"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1443448353 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la fenêtre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a298551396 = messageFormatterFn((function(  ) {
  return function(d) { return "À destination de"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1623066198 = messageFormatterFn((function(  ) {
  return function(d) { return "Arrivée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1930875303 = messageFormatterFn((function(  ) {
  return function(d) { return "Départ"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a176901012 = messageFormatterFn((function(  ) {
  return function(d) { return "Date"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b443427934 = messageFormatterFn((function(  ) {
  return function(d) { return "Voyageurs"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a250737060 = messageFormatterFn((function(  ) {
  return function(d) { return "Rechercher"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a195496238 = messageFormatterFn((function(  ) {
  return function(d) { return "Plus d’informations sur l’hébergement " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1234161845 = messageFormatterFn((function(  ) {
  return function(d) { return "Ouverture de l’hébergement " + d["0"] + " dans une nouvelle fenêtre, retourner à l’onglet d’origine pour continuer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a327387878 = messageFormatterFn((function(  ) {
  return function(d) { return "Résultats de la recherche"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a873785065 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une destination."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1873176675 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date d’arrivée valide."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1729637570 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez les dates de votre voyage"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2098990616 = messageFormatterFn((function(  ) {
  return function(d) { return "La date de départ doit être postérieure à la date d’arrivée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b217948304 = messageFormatterFn((function(  ) {
  return function(d) { return "La date de départ ne peut pas être plus de 28 jours après la date d’arrivée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1563879444 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date de départ valide."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1052698918 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez le nombre de voyageurs."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a566821411 = messageFormatterFn((function(  ) {
  return function(d) { return "Indiquez l’âge du voyageur enfant."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1970509709 = messageFormatterFn((function(  ) {
  return function(d) { return "Indiquez l’âge des voyageurs enfants."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1859173265 = messageFormatterFn((function(  ) {
  return function(d) { return "Les dates du séjour doivent être comprises dans les dates du voyage."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1698227466 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionner"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1323609032 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " chambre";}, one: function() { return number(d["0"]) + " chambre";}, two: function() { return number(d["0"]) + " chambres";}, few: function() { return number(d["0"]) + " chambres";}, many: function() { return number(d["0"]) + " chambres";}, other: function() { return number(d["0"]) + " chambres";} }) + ", " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " pers.";}, one: function() { return number(d["1"]) + " pers.";}, two: function() { return number(d["1"]) + " pers.";}, few: function() { return number(d["1"]) + " pers.";}, many: function() { return number(d["1"]) + " pers.";}, other: function() { return number(d["1"]) + " pers.";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1203205848 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " personne";}, one: function() { return number(d["1"]) + " personne";}, two: function() { return number(d["1"]) + " personnes";}, few: function() { return number(d["1"]) + " personnes";}, many: function() { return number(d["1"]) + " personnes";}, other: function() { return number(d["1"]) + " personnes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1238661046 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " personne";}, one: function() { return number(d["1"]) + " personne";}, two: function() { return number(d["1"]) + " personnes";}, few: function() { return number(d["1"]) + " personnes";}, many: function() { return number(d["1"]) + " personnes";}, other: function() { return number(d["1"]) + " personnes";} }) + ", animaux"; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1652402667 = messageFormatterFn((function(  ) {
  return function(d) { return "Voyageurs"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1772826665 = messageFormatterFn((function(  ) {
  return function(d) { return "Chambre " + d["0"] + " ajoutée. Modifiez les informations des voyageurs ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a483832375 = messageFormatterFn((function(  ) {
  return function(d) { return "Chambre supprimée. Modifiez les informations des voyageurs pour la chambre " + d["0"] + " ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1449447597 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulez et fermez la page de sélection des voyageurs sans sauvegarder les changements. Ou modifiez les informations des voyageurs ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1283538259 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b599680549 = messageFormatterFn((function(  ) {
  return function(d) { return "Sauvegardez les changements et fermez la page de sélection des voyageurs."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1240242767 = messageFormatterFn((function(  ) {
  return function(d) { return "Ajouter une autre chambre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1769254896 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimer la chambre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a425330200 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimez la chambre " + d["0"] + " sur " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b491869046 = messageFormatterFn((function(  ) {
  return function(d) { return "Âge de l’enfant " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1620380350 = messageFormatterFn((function(  ) {
  return function(d) { return "Chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b286521315 = messageFormatterFn((function(  ) {
  return function(d) { return "Chambre " + d["0"] + " sur " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a994350785 = messageFormatterFn((function(  ) {
  return function(d) { return "Âge de l’enfant " + d["0"] + " : " + d["1"] + " ans"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a702186343 = messageFormatterFn((function(  ) {
  return function(d) { return "Moins de 1 an"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1566838905 = messageFormatterFn((function(  ) {
  return function(d) { return "Enfants"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b464955088 = messageFormatterFn((function(  ) {
  return function(d) { return "(0 à 17 ans)"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b631083343 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " adulte";}, one: function() { return number(d["0"]) + " adulte";}, two: function() { return number(d["0"]) + " adultes";}, few: function() { return number(d["0"]) + " adultes";}, many: function() { return number(d["0"]) + " adultes";}, other: function() { return number(d["0"]) + " adultes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a190521847 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " enfant";}, one: function() { return number(d["0"]) + " enfant";}, two: function() { return number(d["0"]) + " enfants";}, few: function() { return number(d["0"]) + " enfants";}, many: function() { return number(d["0"]) + " enfants";}, other: function() { return number(d["0"]) + " enfants";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a20329407 = messageFormatterFn((function(  ) {
  return function(d) { return "Adultes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b375534085 = messageFormatterFn((function(  ) {
  return function(d) { return "Enlever des enfants dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1671075391 = messageFormatterFn((function(  ) {
  return function(d) { return "Enlever des adultes dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a390683607 = messageFormatterFn((function(  ) {
  return function(d) { return "Ajouter des enfants dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1228445 = messageFormatterFn((function(  ) {
  return function(d) { return "Ajouter des adultes dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1085500393 = messageFormatterFn((function(  ) {
  return function(d) { return "Animaux de compagnie"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a158546355 = messageFormatterFn((function(  ) {
  return function(d) { return "Animaux inclus ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1151512935 = messageFormatterFn((function(  ) {
  return function(d) { return "Oui"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a39630361 = messageFormatterFn((function(  ) {
  return function(d) { return "Non"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a351509027 = messageFormatterFn((function(  ) {
  return function(d) { return "L’hébergement " + d["0"] + " a été ajouté à vos listes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b431021949 = messageFormatterFn((function(  ) {
  return function(d) { return "S’ouvre dans une nouvelle fenêtre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b675988818 = messageFormatterFn((function(  ) {
  return function(d) { return "Avis des voyageurs"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1111289818 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulez et retournez aux informations de l’hôtel."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1657465666 = messageFormatterFn((function(  ) {
  return function(d) { return "Vérifier la disponibilité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1734326633 = messageFormatterFn((function(  ) {
  return function(d) { return "Vérifier la disponibilité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a470085495 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifiez la recherche"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b193564154 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date d’arrivée ultérieure"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a860869218 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date d’arrivée antérieure"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1250270567 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date de départ ultérieure"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b195837195 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez une date de départ antérieure"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1728858353 = messageFormatterFn((function(  ) {
  return function(d) { return "Le prix était de " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1657233245 = messageFormatterFn((function(  ) {
  return function(d) { return "Le prix est de " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b116030206 = messageFormatterFn((function(  ) {
  return function(d) { return "Le prix est maintenant de " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1452441648 = messageFormatterFn((function(  ) {
  return function(d) { return "Le prix était de " + d["0"] + ", il est maintenant de " + d["1"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1489326103 = messageFormatterFn((function(  ) {
  return function(d) { return "par nuit"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1279882631 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulez et retournez aux informations de l’hôtel."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2082804911 = messageFormatterFn((function(  ) {
  return function(d) { return "Plus de détails"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1933609637 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermez et retournez aux informations de l’hôtel."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b479753211 = messageFormatterFn((function(  ) {
  return function(d) { return "Une erreur s’est produite."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1886224705 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez tenter une nouvelle recherche."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b323061177 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir les options et réserver"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1853088518 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous pourriez aussi aimer..."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b566208967 = messageFormatterFn((function(  ) {
  return function(d) { return "Masquer les filtres"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b971790271 = messageFormatterFn((function(  ) {
  return function(d) { return "Trier et filtrer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b884029123 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1803580878 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a76240229 = messageFormatterFn((function(  ) {
  return function(d) { return "Cliquez sur appliquer ou revenez en arrière pour fermer les filtres."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1185383911 = messageFormatterFn((function(  ) {
  return function(d) { return "Prix minimum"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a306226297 = messageFormatterFn((function(  ) {
  return function(d) { return "Prix maximum"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1343143394 = messageFormatterFn((function(  ) {
  return function(d) { return "Nombre d’étoiles"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1605360497 = messageFormatterFn((function(  ) {
  return function(d) { return "Trier par"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a381572046 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrer selon"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1476220558 = messageFormatterFn((function(  ) {
  return function(d) { return "Retour à la recherche d’hôtels"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1241086916 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherche parmi des milliers d’hébergements"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1000110943 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherche de milliers d’offres de formules en cours"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1559637875 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " filtre appliqué";}, one: function() { return number(d["0"]) + " filtre appliqué";}, two: function() { return number(d["0"]) + " filtres appliqués";}, few: function() { return number(d["0"]) + " filtres appliqués";}, many: function() { return number(d["0"]) + " filtres appliqués";}, other: function() { return number(d["0"]) + " filtres appliqués";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1772886733 = messageFormatterFn((function(  ) {
  return function(d) { return "Trier et filtrer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a200272313 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtrer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a63244372 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher la carte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1172093071 = messageFormatterFn((function(  ) {
  return function(d) { return "chargement des résultats"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b957580782 = messageFormatterFn((function(  ) {
  return function(d) { return "résultats mis à jour"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b281371550 = messageFormatterFn((function(  ) {
  return function(d) { return "impossible de trouver des résultats"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1422771762 = messageFormatterFn((function(  ) {
  return function(d) { return "pas de résultats"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a968928716 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherche d’hôtels"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1662793275 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1526950502 = messageFormatterFn((function(  ) {
  return function(d) { return "Essayez plutôt ces dates"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b294145812 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir plus de dates"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b331966928 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir moins de dates"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1350052641 = messageFormatterFn((function(  ) {
  return function(d) { return "Résultats de la recherche d’hôtels à " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b820270653 = messageFormatterFn((function(  ) {
  return function(d) { return "Résultats de la recherche de locations de vacances pour " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1465030898 = messageFormatterFn((function(  ) {
  return function(d) { return "Résultats de la recherche d’hôtels invalides"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b533406188 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher plus"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1910214266 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, nous n’avons trouvé aucun résultat. Essayez d’ajuster vos critères de recherche."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2010085872 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtre sélectionné"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a336953778 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtres sélectionnés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a222261490 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination manquante"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a540231486 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b559674722 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimer tous les filtres"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1731198365 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " voyageur";}, one: function() { return number(d["0"]) + " voyageur";}, two: function() { return number(d["0"]) + " voyageurs";}, few: function() { return number(d["0"]) + " voyageurs";}, many: function() { return number(d["0"]) + " voyageurs";}, other: function() { return number(d["0"]) + " voyageurs";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b69393483 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, nous rencontrons un problème."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1680084066 = messageFormatterFn((function(  ) {
  return function(d) { return "Réessayer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b226912486 = messageFormatterFn((function(  ) {
  return function(d) { return "Sauvegardez " + d["0"] + " dans vos listes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b148277488 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimez " + d["0"] + " de vos listes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b374794200 = messageFormatterFn((function(  ) {
  return function(d) { return "Détails de votre prochain séjour"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b891852401 = messageFormatterFn((function(  ) {
  return function(d) { return "Chercher dans cette zone"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1343786691 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, une erreur s’est produite. Veuillez réessayer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1099430116 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la carte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b894125612 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " hébergement";}, one: function() { return number(d["0"]) + " hébergement";}, two: function() { return number(d["0"]) + " hébergements";}, few: function() { return number(d["0"]) + " hébergements";}, many: function() { return number(d["0"]) + " hébergements";}, other: function() { return number(d["0"]) + " hébergements";} }) + "\nà partir de " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2005667427 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " hébergement";}, one: function() { return number(d["0"]) + " hébergement";}, two: function() { return number(d["0"]) + " hébergements";}, few: function() { return number(d["0"]) + " hébergements";}, many: function() { return number(d["0"]) + " hébergements";}, other: function() { return number(d["0"]) + " hébergements";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a462646052 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir plus"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a154472183 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir moins"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1151901051 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, une erreur s’est produite de notre côté"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1629809351 = messageFormatterFn((function(  ) {
  return function(d) { return "Article suivant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a920782027 = messageFormatterFn((function(  ) {
  return function(d) { return "Article précédent"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1874886510 = messageFormatterFn((function(  ) {
  return function(d) { return "Paiement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a990083087 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Votre voyage (" + plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " chambre";}, one: function() { return number(d["0"]) + " chambre";}, two: function() { return number(d["0"]) + " chambres";}, few: function() { return number(d["0"]) + " chambres";}, many: function() { return number(d["0"]) + " chambres";}, other: function() { return number(d["0"]) + " chambres";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1119625496 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Votre voyage (" + plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " hébergement";}, one: function() { return number(d["0"]) + " hébergement";}, two: function() { return number(d["0"]) + " hébergements";}, few: function() { return number(d["0"]) + " hébergements";}, many: function() { return number(d["0"]) + " hébergements";}, other: function() { return number(d["0"]) + " hébergements";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1372895060 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionner votre prochaine chambre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2130371249 = messageFormatterFn((function(  ) {
  return function(d) { return "Plus disponible"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1367688669 = messageFormatterFn((function(  ) {
  return function(d) { return "Un ou plusieurs de vos hébergements pour votre voyage ne sont plus disponibles. Souhaitez-vous tout de même procéder au paiement ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b986242966 = messageFormatterFn((function(  ) {
  return function(d) { return "par chambre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2077013486 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " personne";}, one: function() { return number(d["0"]) + " personne";}, two: function() { return number(d["0"]) + " personnes";}, few: function() { return number(d["0"]) + " personnes";}, many: function() { return number(d["0"]) + " personnes";}, other: function() { return number(d["0"]) + " personnes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1959776234 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " chambre";}, one: function() { return number(d["0"]) + " chambre";}, two: function() { return number(d["0"]) + " chambres";}, few: function() { return number(d["0"]) + " chambres";}, many: function() { return number(d["0"]) + " chambres";}, other: function() { return number(d["0"]) + " chambres";} }) + ", " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " personne";}, one: function() { return number(d["1"]) + " personne";}, two: function() { return number(d["1"]) + " personnes";}, few: function() { return number(d["1"]) + " personnes";}, many: function() { return number(d["1"]) + " personnes";}, other: function() { return number(d["1"]) + " personnes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2136742045 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " par nuit"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b843368523 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifier la chambre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b856265825 = messageFormatterFn((function(  ) {
  return function(d) { return "Code copié dans le presse-papier."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1434795576 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, nous rencontrons un problème."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b903818073 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez réessayer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1430958063 = messageFormatterFn((function(  ) {
  return function(d) { return "Réessayer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a759594146 = messageFormatterFn((function(  ) {
  return function(d) { return "Prise en charge et restitution du véhicule"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1931960075 = messageFormatterFn((function(  ) {
  return function(d) { return "Heure de prise en charge"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b247604457 = messageFormatterFn((function(  ) {
  return function(d) { return "Heure de restitution"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b262846410 = messageFormatterFn((function(  ) {
  return function(d) { return "Location de véhicule"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1603078621 = messageFormatterFn((function(  ) {
  return function(d) { return "L’heure de restitution doit avoir lieu au moins 2 heures après l’heure de prise en charge."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1284070223 = messageFormatterFn((function(  ) {
  return function(d) { return "00 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1284159596 = messageFormatterFn((function(  ) {
  return function(d) { return "00 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1284993744 = messageFormatterFn((function(  ) {
  return function(d) { return "01 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1285083117 = messageFormatterFn((function(  ) {
  return function(d) { return "01 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1285917265 = messageFormatterFn((function(  ) {
  return function(d) { return "02 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1286006638 = messageFormatterFn((function(  ) {
  return function(d) { return "02 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1286840786 = messageFormatterFn((function(  ) {
  return function(d) { return "03 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1286930159 = messageFormatterFn((function(  ) {
  return function(d) { return "03 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1287764307 = messageFormatterFn((function(  ) {
  return function(d) { return "04 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1287853680 = messageFormatterFn((function(  ) {
  return function(d) { return "04 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1288687828 = messageFormatterFn((function(  ) {
  return function(d) { return "05 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1288777201 = messageFormatterFn((function(  ) {
  return function(d) { return "05 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1289611349 = messageFormatterFn((function(  ) {
  return function(d) { return "06 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1289700722 = messageFormatterFn((function(  ) {
  return function(d) { return "06 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1290534870 = messageFormatterFn((function(  ) {
  return function(d) { return "07 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1290624243 = messageFormatterFn((function(  ) {
  return function(d) { return "07 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1291458391 = messageFormatterFn((function(  ) {
  return function(d) { return "08 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1291547764 = messageFormatterFn((function(  ) {
  return function(d) { return "08 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1292381912 = messageFormatterFn((function(  ) {
  return function(d) { return "09 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1292471285 = messageFormatterFn((function(  ) {
  return function(d) { return "09 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1312699374 = messageFormatterFn((function(  ) {
  return function(d) { return "10 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1312788747 = messageFormatterFn((function(  ) {
  return function(d) { return "10 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1313622895 = messageFormatterFn((function(  ) {
  return function(d) { return "11 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1313712268 = messageFormatterFn((function(  ) {
  return function(d) { return "11 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1314546416 = messageFormatterFn((function(  ) {
  return function(d) { return "12 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1314635789 = messageFormatterFn((function(  ) {
  return function(d) { return "12 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1315469937 = messageFormatterFn((function(  ) {
  return function(d) { return "13 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1315559310 = messageFormatterFn((function(  ) {
  return function(d) { return "13 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1316393458 = messageFormatterFn((function(  ) {
  return function(d) { return "14 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1316482831 = messageFormatterFn((function(  ) {
  return function(d) { return "14 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1317316979 = messageFormatterFn((function(  ) {
  return function(d) { return "15 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1317406352 = messageFormatterFn((function(  ) {
  return function(d) { return "15 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1318240500 = messageFormatterFn((function(  ) {
  return function(d) { return "16 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1318329873 = messageFormatterFn((function(  ) {
  return function(d) { return "16 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1319164021 = messageFormatterFn((function(  ) {
  return function(d) { return "17 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1319253394 = messageFormatterFn((function(  ) {
  return function(d) { return "17 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1320087542 = messageFormatterFn((function(  ) {
  return function(d) { return "18 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1320176915 = messageFormatterFn((function(  ) {
  return function(d) { return "18 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1321011063 = messageFormatterFn((function(  ) {
  return function(d) { return "19 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1321100436 = messageFormatterFn((function(  ) {
  return function(d) { return "19 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1341328525 = messageFormatterFn((function(  ) {
  return function(d) { return "20 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1341417898 = messageFormatterFn((function(  ) {
  return function(d) { return "20 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1342252046 = messageFormatterFn((function(  ) {
  return function(d) { return "21 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1342341419 = messageFormatterFn((function(  ) {
  return function(d) { return "21 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1343175567 = messageFormatterFn((function(  ) {
  return function(d) { return "22 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1343264940 = messageFormatterFn((function(  ) {
  return function(d) { return "22 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1344099088 = messageFormatterFn((function(  ) {
  return function(d) { return "23 h 00"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1344188461 = messageFormatterFn((function(  ) {
  return function(d) { return "23 h 30"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a101647184 = messageFormatterFn((function(  ) {
  return function(d) { return "Vols directs uniquement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1106687549 = messageFormatterFn((function(  ) {
  return function(d) { return "Classe souhaitée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1542232949 = messageFormatterFn((function(  ) {
  return function(d) { return "Économique"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a719612956 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a324372981 = messageFormatterFn((function(  ) {
  return function(d) { return "Affaires"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1395435043 = messageFormatterFn((function(  ) {
  return function(d) { return "Première classe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1360130228 = messageFormatterFn((function(  ) {
  return function(d) { return "Voyageurs"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a444450254 = messageFormatterFn((function(  ) {
  return function(d) { return "Il doit y avoir au moins un voyageur (âgé d’au moins 6 ans) pour chaque jeune enfant voyageant sur les genoux."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b830241271 = messageFormatterFn((function(  ) {
  return function(d) { return "Bébés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b995455726 = messageFormatterFn((function(  ) {
  return function(d) { return "(2 à 17 ans)"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a540752288 = messageFormatterFn((function(  ) {
  return function(d) { return "moins de 2 ans"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b785169038 = messageFormatterFn((function(  ) {
  return function(d) { return "Âge du bébé " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a508064682 = messageFormatterFn((function(  ) {
  return function(d) { return "Réduire le nombre de jeunes enfants dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1615161722 = messageFormatterFn((function(  ) {
  return function(d) { return "Augmenter le nombre de jeunes enfants dans la chambre " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1688449176 = messageFormatterFn((function(  ) {
  return function(d) { return "Les enfants de moins de 2 ans doivent être assis dans un siège ou sur les genoux."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1548766784 = messageFormatterFn((function(  ) {
  return function(d) { return "Sur les genoux"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a218821346 = messageFormatterFn((function(  ) {
  return function(d) { return "Avec siège réservé"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a943886653 = messageFormatterFn((function(  ) {
  return function(d) { return "Conditions de la compagnie aérienne pour l’âge des passagers"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a717242647 = messageFormatterFn((function(  ) {
  return function(d) { return "Ville de départ"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b900146145 = messageFormatterFn((function(  ) {
  return function(d) { return "Date de départ"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b861243813 = messageFormatterFn((function(  ) {
  return function(d) { return "Date de retour"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1974586567 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez sélectionner une ville de départ."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1136464333 = messageFormatterFn((function(  ) {
  return function(d) { return "Je cherche un hébergement pour une partie de mon voyage uniquement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1281289804 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolé, une erreur s’est produite de notre côté. Veuillez réessayer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2126429496 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez au moins un hébergement supplémentaire afin d’effectuer la comparaison"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1169763515 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vous avez sélectionné " + d["0"] + "/" + plural(d["1"], 0, pluralFuncs["fr-BE"], { 0: function() { return number(d["1"]) + " hébergement";}, one: function() { return number(d["1"]) + " hébergement";}, two: function() { return number(d["1"]) + " hébergements";}, few: function() { return number(d["1"]) + " hébergements";}, many: function() { return number(d["1"]) + " hébergements";}, other: function() { return number(d["1"]) + " hébergements";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1051019841 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Vous avez sélectionné " + d["0"] + " sur " + plural(d["1"], 0, pluralFuncs["fr-BE"], { 0: function() { return number(d["1"]) + " hébergement";}, one: function() { return number(d["1"]) + " hébergement";}, two: function() { return number(d["1"]) + " hébergements";}, few: function() { return number(d["1"]) + " hébergements";}, many: function() { return number(d["1"]) + " hébergements";}, other: function() { return number(d["1"]) + " hébergements";} }) + " afin de les comparer"; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1071773489 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a789240493 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparez les hébergements sélectionnés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1294708345 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1795341067 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparez les hébergements sélectionnés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b23528153 = messageFormatterFn((function(  ) {
  return function(d) { return "Consulter"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b512565931 = messageFormatterFn((function(  ) {
  return function(d) { return "Cliquez ici pour consulter l’hébergement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1452083590 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2118300758 = messageFormatterFn((function(  ) {
  return function(d) { return "Cliquez ici pour supprimer l’hébergement de la comparaison"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a850068172 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la comparaison d’hébergements"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1643842458 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparez les hébergements"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a317738255 = messageFormatterFn((function(  ) {
  return function(d) { return "Affichez jusqu’à 5 hébergements côte à côte pour vous aider à décider. Sélectionnez « Comparer » pour commencer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1259776597 = messageFormatterFn((function(  ) {
  return function(d) { return "Affichez jusqu’à 5 hébergements côte à côte pour vous aider à décider."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1500715277 = messageFormatterFn((function(  ) {
  return function(d) { return "Essayer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a722291953 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1654307653 = messageFormatterFn((function(  ) {
  return function(d) { return "Désactiver la comparaison"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a255895593 = messageFormatterFn((function(  ) {
  return function(d) { return "Me le rappeler plus tard"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1139333850 = messageFormatterFn((function(  ) {
  return function(d) { return "Comparaison des hébergements"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1598683253 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionnez « Comparer » dans les résultats de recherche pour commencer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1980601425 = messageFormatterFn((function(  ) {
  return function(d) { return "Affichez jusqu’à 5 hébergements côte à côte."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2000812840 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " est indisponible."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a619172789 = messageFormatterFn((function(  ) {
  return function(d) { return "Départ impossible le " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b387382428 = messageFormatterFn((function(  ) {
  return function(d) { return "Arrivée impossible le " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1419337642 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a46222627 = messageFormatterFn((function(  ) {
  return function(d) { return "Personnalisez votre hébergement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2074959677 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la section Personnalisez votre hébergement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1194731957 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a402072989 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuler"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b737691555 = messageFormatterFn((function(  ) {
  return function(d) { return "Ignorer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1655382693 = messageFormatterFn((function(  ) {
  return function(d) { return "Et voilà !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a12424487 = messageFormatterFn((function(  ) {
  return function(d) { return "Supprimer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a597474174 = messageFormatterFn((function(  ) {
  return function(d) { return "sélectionné"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a501482127 = messageFormatterFn((function(  ) {
  return function(d) { return "Chargement en cours"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1204490912 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2103299450 = messageFormatterFn((function(  ) {
  return function(d) { return "S’ouvre dans une nouvelle fenêtre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b908448460 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher plus"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a953280769 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher moins"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1341214339 = messageFormatterFn((function(  ) {
  return function(d) { return "Voir plus"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1784286576 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher moins"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b857775397 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " sélectionné. Veuillez choisir une date de départ."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b516575850 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " sélectionné. Cliquez sur Valider pour sauvegarder ces dates et fermer le calendrier."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b146000326 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", date actuelle d’arrivée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a510983591 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", date actuelle de départ."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1124988669 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", date désactivée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a525106106 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", mois en cours"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1398612373 = messageFormatterFn((function(  ) {
  return function(d) { return "Affiché actuellement : " + d["0"] + " et " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b744586385 = messageFormatterFn((function(  ) {
  return function(d) { return "Calendrier ouvert. Choisissez une date dans le tableau ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b942538241 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulez et fermez le calendrier sans sauvegarder les changements. Ou choisissez une date dans le tableau ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b573950415 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer les dates sélectionnées"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a322234490 = messageFormatterFn((function(  ) {
  return function(d) { return "Sauvegardez les changements et fermez le calendrier."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2079869037 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " nuit";}, one: function() { return number(d["0"]) + " nuit";}, two: function() { return number(d["0"]) + " nuits";}, few: function() { return number(d["0"]) + " nuits";}, many: function() { return number(d["0"]) + " nuits";}, other: function() { return number(d["0"]) + " nuits";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a683010211 = messageFormatterFn((function(  ) {
  return function(d) { return "Arrivée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1698295692 = messageFormatterFn((function(  ) {
  return function(d) { return "Départ"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1639906869 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer les dates"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1015244308 = messageFormatterFn((function(  ) {
  return function(d) { return "Valider"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b927621190 = messageFormatterFn((function(  ) {
  return function(d) { return "Rechercher"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a688125040 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifiez la date d’arrivée dans le tableau ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a915692097 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifiez la date de départ dans le tableau ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1153825808 = messageFormatterFn((function(  ) {
  return function(d) { return "sélectionnée. "; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b52939491 = messageFormatterFn((function(  ) {
  return function(d) { return "Date sélectionnée : " + d["0"] + ". Fermez le calendrier ou changez la date sélectionnée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a952559589 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates sélectionnées : du " + d["0"] + " au " + d["1"] + ". Fermez le calendrier ou changez les dates sélectionnées."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1524192747 = messageFormatterFn((function(  ) {
  return function(d) { return "Date sélectionnée : " + d["0"] + ". " + d["1"] + ". Fermez le calendrier ou changez la date sélectionnée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a453184819 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates sélectionnées : du " + d["0"] + " au " + d["1"] + ". " + d["2"] + ". Fermez le calendrier ou changez les dates sélectionnées."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a309082452 = messageFormatterFn((function(  ) {
  return function(d) { return "Choisir la date d’arrivée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1041007987 = messageFormatterFn((function(  ) {
  return function(d) { return "Choisir la date de départ"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2049052996 = messageFormatterFn((function(  ) {
  return function(d) { return "vierge"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1820438298 = messageFormatterFn((function(  ) {
  return function(d) { return "Mois précédent"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1129944450 = messageFormatterFn((function(  ) {
  return function(d) { return "Mois suivant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a831235025 = messageFormatterFn((function(  ) {
  return function(d) { return "Bouton passer « " + d["0"] + " »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a695208041 = messageFormatterFn((function(  ) {
  return function(d) { return "Du " + d["0"] + " au " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1113069684 = messageFormatterFn((function(  ) {
  return function(d) { return "Les dates ont été effacées"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1973320441 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "il y a " + plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return "are " + number(d["0"]) + " résultat";}, one: function() { return "is " + number(d["0"]) + " résultat";}, two: function() { return "are " + number(d["0"]) + " résultats";}, few: function() { return "are " + number(d["0"]) + " résultats";}, many: function() { return "are " + number(d["0"]) + " résultats";}, other: function() { return "are " + number(d["0"]) + " résultats";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1841405214 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Il y a " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " résultat disponible";}, one: function() { return number(d["1"]) + " résultat disponible";}, two: function() { return number(d["1"]) + " résultats disponibles";}, few: function() { return number(d["1"]) + " résultats disponibles";}, many: function() { return number(d["1"]) + " résultats disponibles";}, other: function() { return number(d["1"]) + " résultats disponibles";} }) + " pour " + d["0"] + ". Utilisez les touches flèches ou faites glisser pour naviguer dans la liste."; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1417888886 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherche sur " + d["0"] + " ouverte, veuillez saisir un terme de recherche."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b526764615 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez sélectionné " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a126304086 = messageFormatterFn((function(  ) {
  return function(d) { return "Le menu est fermé."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1247769956 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Champ de la recherche actif pour « " + d["0"] + " » avec actuellement " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " suggestion";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + " pour " + d["2"] + ". Naviguez dans la liste ci-dessous."; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a365752603 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Recherche active pour « " + d["0"] + " », avec " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " suggestion";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + " Saisissez un terme de recherche ou naviguez dans la liste ci-dessous."; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a914640777 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Recherche active pour « " + d["0"] + " », l’option " + d["1"] + " est sélectionnée. Il y a " + plural(d["2"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["2"]) + " suggestion";}, one: function() { return number(d["2"]) + " suggestion";}, two: function() { return number(d["2"]) + " suggestions";}, few: function() { return number(d["2"]) + " suggestions";}, many: function() { return number(d["2"]) + " suggestions";}, other: function() { return number(d["2"]) + " suggestions";} }) + " pour " + d["3"] + ". Naviguez dans la liste ci-dessous."; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b986428611 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1922295700 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer tout"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2131017735 = messageFormatterFn((function(  ) {
  return function(d) { return "Options sélectionnées"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1567545772 = messageFormatterFn((function(  ) {
  return function(d) { return "Option " + d["0"] + " supprimée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1092986555 = messageFormatterFn((function(  ) {
  return function(d) { return "Toutes les sélections ont été effacées."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a912555788 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez saisi des informations dans le champ de texte. Veuillez rechercher ou sélectionner parmi les catégories ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b991474323 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherche pour « " + d["0"] + " »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1990668052 = messageFormatterFn((function(  ) {
  return function(d) { return "Aucun résultat pour « " + d["0"] + " »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1239782466 = messageFormatterFn((function(  ) {
  return function(d) { return "Aéroport"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1536908821 = messageFormatterFn((function(  ) {
  return function(d) { return "Hôtel"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a591250433 = messageFormatterFn((function(  ) {
  return function(d) { return "Lieu d’intérêt"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1167368822 = messageFormatterFn((function(  ) {
  return function(d) { return "À proximité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b314600601 = messageFormatterFn((function(  ) {
  return function(d) { return "Essayez : « " + d["0"] + " »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1778203230 = messageFormatterFn((function(  ) {
  return function(d) { return "Région/ville"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1979884622 = messageFormatterFn((function(  ) {
  return function(d) { return "Aéroport"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1333647526 = messageFormatterFn((function(  ) {
  return function(d) { return "Attraction"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b396475145 = messageFormatterFn((function(  ) {
  return function(d) { return "Hôtel"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1931297481 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a896733887 = messageFormatterFn((function(  ) {
  return function(d) { return "Gare de train"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1371653426 = messageFormatterFn((function(  ) {
  return function(d) { return "Station de métro"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1643833458 = messageFormatterFn((function(  ) {
  return function(d) { return "Destinations à proximité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1080336937 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherches récentes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a630982205 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherches similaires"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b559180904 = messageFormatterFn((function(  ) {
  return function(d) { return "Destinations à la mode"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a869658332 = messageFormatterFn((function(  ) {
  return function(d) { return "Destinations populaires"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b999618144 = messageFormatterFn((function(  ) {
  return function(d) { return "Recherches populaires"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a128905378 = messageFormatterFn((function(  ) {
  return function(d) { return "Votre position"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b980921377 = messageFormatterFn((function(  ) {
  return function(d) { return "Le partage de votre emplacement est désactivé"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1087007761 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous ne sommes pas en mesure de déterminer votre emplacement. Veuillez activer les services de localisation sur votre appareil afin que nous puissions déterminer votre emplacement ou bien indiquez votre destination."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1943831603 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " chambre";}, one: function() { return number(d["0"]) + " chambre";}, two: function() { return number(d["0"]) + " chambres";}, few: function() { return number(d["0"]) + " chambres";}, many: function() { return number(d["0"]) + " chambres";}, other: function() { return number(d["0"]) + " chambres";} }) + ", " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]) + " personne";}, one: function() { return number(d["1"]) + " personne";}, two: function() { return number(d["1"]) + " personnes";}, few: function() { return number(d["1"]) + " personnes";}, many: function() { return number(d["1"]) + " personnes";}, other: function() { return number(d["1"]) + " personnes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a165998147 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " personne";}, one: function() { return number(d["0"]) + " personne";}, two: function() { return number(d["0"]) + " personnes";}, few: function() { return number(d["0"]) + " personnes";}, many: function() { return number(d["0"]) + " personnes";}, other: function() { return number(d["0"]) + " personnes";} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b851924799 = messageFormatterFn((function(  ) {
  return function(d) { return "La valeur du champ " + d["0"] + " est désormais " + d["1"] + ". La valeur du champ " + d["2"] + " est désormais " + d["3"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1836237936 = messageFormatterFn((function(  ) {
  return function(d) { return "Inverser les champs " + d["0"] + " et " + d["1"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a361833667 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher le mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a47491528 = messageFormatterFn((function(  ) {
  return function(d) { return "Masquer le mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a346634497 = messageFormatterFn((function(  ) {
  return function(d) { return "Affiché actuellement : " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a635915252 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " sur " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a89624642 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo " + d["0"] + " sur " + d["1"] + ". " + d["2"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a744751423 = messageFormatterFn((function(  ) {
  return function(d) { return "Charger la photo suivante"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1545808197 = messageFormatterFn((function(  ) {
  return function(d) { return "Charger la photo précédente"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1227183361 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher les " + d["0"] + " photos"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a757073238 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Afficher " + plural(d["0"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["0"]) + " photo";}, one: function() { return number(d["0"]) + " photo";}, two: function() { return number(d["0"]) + " photos";}, few: function() { return number(d["0"]) + " photos";}, many: function() { return number(d["0"]) + " photos";}, other: function() { return number(d["0"]) + " photos";} }) + " pour " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1951921939 = messageFormatterFn((function(  ) {
  return function(d) { return "Complété :"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b113964543 = messageFormatterFn((function(  ) {
  return function(d) { return "Actuellement :"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1684300945 = messageFormatterFn((function(  ) {
  return function(d) { return "Étape " + d["0"] + " sur " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a775941133 = messageFormatterFn((function(  ) {
  return function(d) { return "Étape " + d["0"] + " sur " + d["1"] + " :"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a265207502 = messageFormatterFn((function(  ) {
  return function(d) { return "Photo " + d["0"] + " sur " + d["1"] + ". " + d["2"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b475176245 = messageFormatterFn((function(  ) {
  return function(d) { return "Image suivante"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b314404281 = messageFormatterFn((function(  ) {
  return function(d) { return "Image précédente"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a20760071 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", agrandir pour afficher en plein écran"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1741147693 = messageFormatterFn((function(  ) {
  return function(d) { return "Miniature " + d["0"] + ", agrandir pour afficher en plein écran"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b840034979 = messageFormatterFn((function(  ) {
  return function(d) { return "Page actuelle"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b528301325 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher plus d’éléments de navigation"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b566122441 = messageFormatterFn((function(  ) {
  return function(d) { return "Afficher moins d’éléments de navigation"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1832852954 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " pour cent, chargement en cours"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1818886443 = messageFormatterFn((function(  ) {
  return function(d) { return "Chargement en cours"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b797205573 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b89901934 = messageFormatterFn((function(  ) {
  return function(d) { return "Une erreur est survenue."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1014739446 = messageFormatterFn((function(  ) {
  return function(d) { return "Essayez de regarder cette vidéo sur www.youtube.com ou activez Javascript pour votre navigateur."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1919843714 = messageFormatterFn((function(  ) {
  return function(d) { return "Lire la vidéo"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1365171922 = messageFormatterFn((function(  ) {
  return function(d) { return "Mettre la vidéo en pause"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b532415866 = messageFormatterFn((function(  ) {
  return function(d) { return "Vidéo en cours de chargement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1406511044 = messageFormatterFn((function(  ) {
  return function(d) { return "Images à 360 degrés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1555131370 = messageFormatterFn((function(  ) {
  return function(d) { return "Il s’agit d’une image à 360 degrés. Appuyez sur la touche de contrôle + flèches ou la touche de commande + flèches pour vous déplacer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1746859337 = messageFormatterFn((function(  ) {
  return function(d) { return "Image affichée actuellement : " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2094331496 = messageFormatterFn((function(  ) {
  return function(d) { return "Déplacement à gauche terminé. Position : " + d["0"] + " degrés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1644981425 = messageFormatterFn((function(  ) {
  return function(d) { return "Déplacement à droite terminé. Position : " + d["0"] + " degrés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a123126140 = messageFormatterFn((function(  ) {
  return function(d) { return "Déplacement vers le haut terminé"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1875034179 = messageFormatterFn((function(  ) {
  return function(d) { return "Déplacement vers le bas terminé"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b229502772 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez atteint le haut de l’image"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b644072918 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez atteint le bas de l’image"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a813159678 = messageFormatterFn((function(  ) {
  return function(d) { return "Sélectionner toutes les lignes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a707515421 = messageFormatterFn((function(  ) {
  return function(d) { return "Désélectionner toutes les lignes"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1211931309 = messageFormatterFn((function(  ) {
  return function(d) { return "Trier la colonne par ordre décroissant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a532714713 = messageFormatterFn((function(  ) {
  return function(d) { return "Trier la colonne par ordre croissant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1882253719 = messageFormatterFn((function(  ) {
  return function(d) { return "La colonne s’affiche désormais dans l’ordre décroissant."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1872395039 = messageFormatterFn((function(  ) {
  return function(d) { return "La colonne s’affiche désormais dans l’ordre croissant."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1954153673 = messageFormatterFn((function(  ) {
  return function(d) { return "Développer la ligne " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1751030360 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Le nombre d’options affichées actuellement est " + d["0"] + " sur " + plural(d["1"], 0, pluralFuncs["fr-BE"], { zero: function() { return number(d["1"]);}, one: function() { return number(d["1"]);}, two: function() { return number(d["1"]);}, few: function() { return number(d["1"]);}, many: function() { return number(d["1"]);}, other: function() { return number(d["1"]);} }); }
})(messageFormat.number, messageFormat.plural, {"fr-BE": Globalize("fr-BE").pluralGenerator()}), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1876648024 = messageFormatterFn((function(  ) {
  return function(d) { return "Les mois affichés sont " + d["0"] + " " + d["1"] + " et " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2110609792 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mois affiché est " + d["0"] + " " + d["1"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1996236629 = messageFormatterFn((function(  ) {
  return function(d) { return "Les mois affichés vont de " + d["0"] + " " + d["1"] + " à " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b992578864 = messageFormatterFn((function(  ) {
  return function(d) { return "Date d’arrivée effacée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1113392889 = messageFormatterFn((function(  ) {
  return function(d) { return "Date de départ effacée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1762513032 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates effacées."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1920491885 = messageFormatterFn((function(  ) {
  return function(d) { return "Effacer les dates"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1810158195 = messageFormatterFn((function(  ) {
  return function(d) { return "Valider"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1921348842 = messageFormatterFn((function(  ) {
  return function(d) { return "Suivant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1466150314 = messageFormatterFn((function(  ) {
  return function(d) { return "Précédent"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1394820988 = messageFormatterFn((function(  ) {
  return function(d) { return "Passer au bouton Valider"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2051438639 = messageFormatterFn((function(  ) {
  return function(d) { return "Passer au bouton " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b907701024 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mois suivant"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2097042848 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mois précédent"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a703646825 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " est la date d’arrivée sélectionnée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1253379346 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " est la date de départ sélectionnée."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1116219515 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " n’est pas une date d’arrivée valide."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a177931104 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " n’est pas une date de départ valide."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2107008303 = messageFormatterFn((function(  ) {
  return function(d) { return "Le " + d["0"] + " est indisponible."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1129792958 = messageFormatterFn((function(  ) {
  return function(d) { return "Date d’aujourd’hui"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a382864736 = messageFormatterFn((function(  ) {
  return function(d) { return "Date d’arrivée sélectionnée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1118716839 = messageFormatterFn((function(  ) {
  return function(d) { return "Date de départ sélectionnée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b964058116 = messageFormatterFn((function(  ) {
  return function(d) { return "Date sélectionnée"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1772724952 = messageFormatterFn((function(  ) {
  return function(d) { return "Du"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1153800081 = messageFormatterFn((function(  ) {
  return function(d) { return "Au"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b350758578 = messageFormatterFn((function(  ) {
  return function(d) { return "Annulez et fermez le calendrier sans sauvegarder les changements. Ou choisissez une date dans le tableau ci-dessous."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1835132829 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " sur " + d["1"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2001307080 = messageFormatterFn((function(  ) {
  return function(d) { return "Appuyez sur la touche Échap pour fermer le menu."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a439853345 = messageFormatterFn((function(  ) {
  return function(d) { return "Appuyez sur la touche Échap pour réduire le menu."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b591541904 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir un nombre inférieur à " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1750506577 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir un nombre supérieur à " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1208872990 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir un nombre compris entre " + d["0"] + " et " + d["1"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1783898703 = messageFormatterFn((function(  ) {
  return function(d) { return "Obligatoire"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1414220083 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter à " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b265183636 = messageFormatterFn((function(  ) {
  return function(d) { return "Bienvenue à nouveau ! Se connecter avec"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a907588846 = messageFormatterFn((function(  ) {
  return function(d) { return "Ravis de vous revoir ! Inscrivez-vous pour économiser 10 % supplémentaires ou plus sur des milliers d’hébergements avec les Prix membres."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a666040588 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b703110079 = messageFormatterFn((function(  ) {
  return function(d) { return "Mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b320827778 = messageFormatterFn((function(  ) {
  return function(d) { return "Besoin d’un compte ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1521576564 = messageFormatterFn((function(  ) {
  return function(d) { return "En cours de connexion"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1623274415 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter avec Facebook"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1273881348 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter avec Google"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b689411732 = messageFormatterFn((function(  ) {
  return function(d) { return "Rester connecté"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1328701513 = messageFormatterFn((function(  ) {
  return function(d) { return "Garder ma session ouverte (utilise des cookies)"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a817566893 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter "; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a817926307 = messageFormatterFn((function(  ) {
  return function(d) { return "S’inscrire"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2048849537 = messageFormatterFn((function(  ) {
  return function(d) { return "Ou <a href=\"" + d["0"] + "\">se connecter avec Facebook</a>"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1119252279 = messageFormatterFn((function(  ) {
  return function(d) { return "Mot de passe oublié"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1350155684 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez votre adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2041670158 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir une adresse e-mail valide."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b88614671 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez votre mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1551690551 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez réessayer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b677339461 = messageFormatterFn((function(  ) {
  return function(d) { return "Oups, une erreur s’est produite"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1561388057 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez corriger l’erreur ci-dessous pour poursuivre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b564195216 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez corriger les 2 erreurs ci-dessous pour poursuivre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b843703462 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter avec l’adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b598588231 = messageFormatterFn((function(  ) {
  return function(d) { return "Ou se connecter avec l’adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1405553104 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1329198799 = messageFormatterFn((function(  ) {
  return function(d) { return "ou"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a987507039 = messageFormatterFn((function(  ) {
  return function(d) { return "Mot de passe oublié ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b111032770 = messageFormatterFn((function(  ) {
  return function(d) { return "Pas encore membre ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2017644280 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a816016711 = messageFormatterFn((function(  ) {
  return function(d) { return "En me connectant, j’accepte les <a href=\"" + d["0"] + "\" target=\"_blank\">Conditions générales d’utilisation du programme " + d["1"] + ". <span class=\"is-visually-hidden\">S’ouvre dans une nouvelle fenêtre</span></a>"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1054058351 = messageFormatterFn((function(  ) {
  return function(d) { return "En me connectant à mon compte " + d["0"] + ", j’accepte les <a href=\"" + d["1"] + "\" target=\"_blank\">conditions générales d’utilisation<span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a> et la <a href=\"" + d["3"] + "\" target=\"_blank\">politique sur la protection des données de " + d["2"] + "<span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a> et les <a href=\"" + d["4"] + "\" target=\"_blank\">conditions générales de vente du programme " + d["5"] + "<span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a>. "; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1264681395 = messageFormatterFn((function(  ) {
  return function(d) { return "Inscrivez-vous au programme <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + ". <span class=\"is-visually-hidden\">S’ouvre dans une nouvelle fenêtre</span></a> En m’inscrivant, j’accepte toutes <a href=\"" + d["3"] + "\" target=\"_blank\">les conditions générales d’utilisation. <span class=\"is-visually-hidden\">S’ouvre dans une nouvelle fenêtre </span></a>"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1855955805 = messageFormatterFn((function(  ) {
  return function(d) { return "Des conditions s’appliquent, les liens se situent en bas de la page"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a112891477 = messageFormatterFn((function(  ) {
  return function(d) { return "Vérifiez votre boîte de réception !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1160398096 = messageFormatterFn((function(  ) {
  return function(d) { return "Réinitialisez votre mot de passe en utilisant le lien que nous vous avons envoyé à l’adresse " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a934752413 = messageFormatterFn((function(  ) {
  return function(d) { return "Renvoyer le lien"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a310652911 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, une erreur s’est produite de notre côté"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1560370762 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez réessayer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1674025519 = messageFormatterFn((function(  ) {
  return function(d) { return "Retour"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1589103537 = messageFormatterFn((function(  ) {
  return function(d) { return "Un nouveau lien a été envoyé."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1697086423 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte sur " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1984873570 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte avec"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1512017712 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte avec l’adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1380775549 = messageFormatterFn((function(  ) {
  return function(d) { return "Ou créer un compte avec l’adresse e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b109042693 = messageFormatterFn((function(  ) {
  return function(d) { return "Prénom et nom"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1514417941 = messageFormatterFn((function(  ) {
  return function(d) { return "Nom et prénom"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1615390192 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mot de passe doit contenir entre 8 et 30 caractères, sans espace."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1606058894 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a553532701 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez déjà un compte ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b467477359 = messageFormatterFn((function(  ) {
  return function(d) { return "En créant un compte, j’accepte les <a href=\"" + d["1"] + "\" target=\"_blank\">Conditions Générales d’Utilisation de " + d["0"] + ",<span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a> la <a href=\"" + d["2"] + "\" target=\"_blank\">Politique sur la protection des données<span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a> et les <a href=\"" + d["3"] + "\" target=\"_blank\">Conditions générales de vente du programme de " + d["4"] + ". <span class=\"is-visually-hidden\">s’ouvre dans une nouvelle fenêtre</span></a>"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a784249144 = messageFormatterFn((function(  ) {
  return function(d) { return "Je souhaite recevoir des e-mails contenant des offres de voyage, des offres spéciales et d’autres informations."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a395421698 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous vous avons envoyé un e-mail pour finaliser la création de votre compte. "; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1222569453 = messageFormatterFn((function(  ) {
  return function(d) { return "Pour finir de créer votre compte, cliquez sur le lien dans l’e-mail envoyé à " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1611948936 = messageFormatterFn((function(  ) {
  return function(d) { return "Réinitialiser votre mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b201151950 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1731106904 = messageFormatterFn((function(  ) {
  return function(d) { return "Envoyer le lien de réinitialisation"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a662768504 = messageFormatterFn((function(  ) {
  return function(d) { return "ou réserver en tant qu’invité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b277495266 = messageFormatterFn((function(  ) {
  return function(d) { return "Choisir un nouveau mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1552827103 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un nouveau mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1208007644 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse e-mail : " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1394531922 = messageFormatterFn((function(  ) {
  return function(d) { return "Enregistrer le mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1318523844 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolé, ce lien a expiré."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1886604903 = messageFormatterFn((function(  ) {
  return function(d) { return "Pour réinitialiser votre mot de passe, veuillez demander un nouveau lien."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a671581913 = messageFormatterFn((function(  ) {
  return function(d) { return "Envoyer le nouveau lien de réinitialisation"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b809166914 = messageFormatterFn((function(  ) {
  return function(d) { return "Retour à la page de connexion"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1121772931 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous vous avons envoyé par e-mail un nouveau lien pour réinitialiser votre mot de passe."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1135075288 = messageFormatterFn((function(  ) {
  return function(d) { return "Quelle est votre adresse e-mail ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a347734045 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez indiquer une adresse e-mail pour que vos fournisseurs de voyage ou " + d["0"] + " puissent vous joindre. Nous vous enverrons un code de sécurité pour vérifier votre identité."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b160894736 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez créé votre compte " + d["0"] + " avec un numéro de téléphone. Veuillez fournir une adresse e-mail pour que nous puissions finaliser votre inscription. Nous vous enverrons un code de sécurité pour vérifier votre identité."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a183371427 = messageFormatterFn((function(  ) {
  return function(d) { return "Envoyer le code de sécurité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b925660277 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez le code de sécurité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1977862755 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir le code de sécurité que nous avons envoyé à l’adresse " + d["0"] + "."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1189838412 = messageFormatterFn((function(  ) {
  return function(d) { return "Code de sécurité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1877364138 = messageFormatterFn((function(  ) {
  return function(d) { return "Soumettre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b199429300 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous n’avez pas reçu d’e-mail ?"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b829968008 = messageFormatterFn((function(  ) {
  return function(d) { return "Demandez un nouveau code"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a882520419 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous vous avons envoyé un nouveau code de sécurité par e-mail."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a53691290 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez un code de sécurité valide"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1583024269 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez excédé le nombre d’essais pour renvoyer le code de sécurité. Veuillez réessayer dans 24 heures."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1674923701 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez excédé le nombre d’essais pour saisir le bon code de sécurité. Veuillez réessayer dans 24 heures."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1643905206 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez saisir le bon code de sécurité."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1963311534 = messageFormatterFn((function(  ) {
  return function(d) { return "L’adresse e-mail que vous avez saisie a déjà été utilisée pour créer un compte sur " + d["0"] + " avec " + d["1"] + ". Essayez de vous connecter avec le compte " + d["1"] + " associé à cette adresse e-mail."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a635808555 = messageFormatterFn((function(  ) {
  return function(d) { return "Par mesure de sécurité, veuillez réinitialiser votre mot de passe pour continuer à vous connecter."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a540290325 = messageFormatterFn((function(  ) {
  return function(d) { return "Si vous possédez un compte avec " + d["0"] + ", nous vous enverrons un e-mail contenant le lien de réinitialisation de votre mot de passe."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1741129162 = messageFormatterFn((function(  ) {
  return function(d) { return "Ravis de vous revoir, " + d["0"] + " !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a598600900 = messageFormatterFn((function(  ) {
  return function(d) { return "Votre nouveau mot de passe a été enregistré."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2040054586 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuer vos achats"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1099375160 = messageFormatterFn((function(  ) {
  return function(d) { return "Bienvenue, " + d["0"] + " !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b817469958 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, une erreur s’est produite de notre côté"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1208952779 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez corriger les " + d["0"] + " erreurs ci-dessous pour poursuivre"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1953046484 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous avez saisi une adresse e-mail inconnue ou un mot de passe incorrect"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b624921436 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, nous n’avons pas pu vous connecter à " + d["0"]; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1045048579 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolé, votre lien de réinitialisation a expiré"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a217331721 = messageFormatterFn((function(  ) {
  return function(d) { return "Veuillez demander un nouveau lien"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b689592433 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolé, votre session a expiré"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1906068649 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez le prénom et le nom"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1333680241 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisir un nom et un prénom"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a270119423 = messageFormatterFn((function(  ) {
  return function(d) { return "Saisissez un nom en utilisant des lettres uniquement"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b194416495 = messageFormatterFn((function(  ) {
  return function(d) { return "Cette adresse e-mail est déjà associée à un compte sur " + d["0"] + ".  "; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1227521093 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mot de passe ne doit pas contenir d’espace."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1692399322 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mot de passe ne peut correspondre à votre adresse e-mail."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1299823262 = messageFormatterFn((function(  ) {
  return function(d) { return "Ce mot de passe peut être facilement deviné."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a461804869 = messageFormatterFn((function(  ) {
  return function(d) { return "Cette adresse e-mail existe déjà."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a837823784 = messageFormatterFn((function(  ) {
  return function(d) { return "Un mot de passe est nécessaire."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1212950574 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mot de passe est incorrect."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a167579794 = messageFormatterFn((function(  ) {
  return function(d) { return "Votre mot de passe doit contenir au moins " + d["0"] + " caractères."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b489336256 = messageFormatterFn((function(  ) {
  return function(d) { return "Le mot de passe doit contenir entre " + d["0"] + " et " + d["1"] + " caractères."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1090048272 = messageFormatterFn((function(  ) {
  return function(d) { return "Cette adresse e-mail a déjà été utilisée pour créer un compte sur " + d["0"] + " avec " + d["1"] + ". Utilisez une autre adresse e-mail ou connectez-vous avec le compte " + d["1"] + " associé à cet e-mail."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1208224092 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, nous ne pouvons pas utiliser votre identifiant Apple pour vous connecter. Nous travaillons pour intégrer les identifiants Apple qui sont des numéros de téléphone. En attendant, veuillez vous connecter en utilisant une autre méthode."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a744731022 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous ne pouvons pas trouver ce compte."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a601506353 = messageFormatterFn((function(  ) {
  return function(d) { return "L’adresse e-mail est nécessaire."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1456383358 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer « Se connecter »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b943597064 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer « Créer un compte »"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1327342371 = messageFormatterFn((function(  ) {
  return function(d) { return "Revenir à la page précédente"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1723730230 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la vérification e-mail"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1565934128 = messageFormatterFn((function(  ) {
  return function(d) { return "Fermer la saisie du code de sécurité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b809848070 = messageFormatterFn((function(  ) {
  return function(d) { return "Réservez en tant qu’invité ou connectez-vous"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b782526488 = messageFormatterFn((function(  ) {
  return function(d) { return "Je suis un nouveau client"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a150851271 = messageFormatterFn((function(  ) {
  return function(d) { return "Vous pourrez créer un compte après le paiement."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b847331322 = messageFormatterFn((function(  ) {
  return function(d) { return "Réserver en tant qu’invité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2245178 = messageFormatterFn((function(  ) {
  return function(d) { return "Je suis déjà client"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1410636054 = messageFormatterFn((function(  ) {
  return function(d) { return "Connectez-vous pour gagner des points à utiliser sur votre réservation."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a482118867 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter et payer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b933452564 = messageFormatterFn((function(  ) {
  return function(d) { return "Ou continuer avec"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b645653426 = messageFormatterFn((function(  ) {
  return function(d) { return "Ravis de vous revoir !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1412806965 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter ou créer un compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1930456470 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a328162668 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous avons envoyé un lien de réinitialisation du mot de passe à " + d["0"] + ". Il peut prendre quelques minutes pour arriver. Consultez votre dossier Spam ou des courriers indésirables si vous ne le trouvez pas dans votre boîte de réception."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a158027805 = messageFormatterFn((function(  ) {
  return function(d) { return "Réinitialisez le mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a434526581 = messageFormatterFn((function(  ) {
  return function(d) { return "Votre mot de passe doit contenir au moins 8 caractères."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b563409025 = messageFormatterFn((function(  ) {
  return function(d) { return "Poursuivre avec le compte lié"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a190911765 = messageFormatterFn((function(  ) {
  return function(d) { return "ou définir un mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b825177057 = messageFormatterFn((function(  ) {
  return function(d) { return "Vérifiez votre boîte de réception !"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b274108378 = messageFormatterFn((function(  ) {
  return function(d) { return "Nous avons envoyé un lien de vérification à " + d["0"] + " pour définir un mot de passe pour votre compte. Il peut prendre quelques minutes pour arriver. Consultez votre dossier Spam ou des courriers indésirables si vous ne le trouvez pas dans votre boîte de réception."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b80961110 = messageFormatterFn((function(  ) {
  return function(d) { return "Définissez un mot de passe"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b879427648 = messageFormatterFn((function(  ) {
  return function(d) { return "Modifier"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1607670690 = messageFormatterFn((function(  ) {
  return function(d) { return "Il semble que vous ayez déjà effectué une réservation avec nous par le passé. Pour des raisons de sécurité, nous avons besoin de vérifier votre adresse e-mail."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1773762688 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilisez le lien de vérification envoyé à " + d["0"] + " pour finaliser la création de votre compte. Il peut prendre quelques minutes pour arriver. Consultez votre dossier Spam ou des courriers indésirables si vous ne le trouvez pas dans votre boîte de réception."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a23070050 = messageFormatterFn((function(  ) {
  return function(d) { return "Mes détails de voyage"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1164694293 = messageFormatterFn((function(  ) {
  return function(d) { return "Mes infos de compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a915329957 = messageFormatterFn((function(  ) {
  return function(d) { return "Mettre à jour mes infos personnelles et préférences."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b719102577 = messageFormatterFn((function(  ) {
  return function(d) { return "Informations TSA"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b2100660365 = messageFormatterFn((function(  ) {
  return function(d) { return "Ajouter un numéro de recours ou de voyageur connu."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b126715425 = messageFormatterFn((function(  ) {
  return function(d) { return "Infos personnelles"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1705087037 = messageFormatterFn((function(  ) {
  return function(d) { return "Partager des infos générales et mes coordonnées."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b224707494 = messageFormatterFn((function(  ) {
  return function(d) { return "Préférences de vol"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b606169986 = messageFormatterFn((function(  ) {
  return function(d) { return "Choisissez les paramètres pour personnaliser votre expérience"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1501185801 = messageFormatterFn((function(  ) {
  return function(d) { return "Programmes de fidélité"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1243590875 = messageFormatterFn((function(  ) {
  return function(d) { return "Enregistrer mes programmes de fidélité de compagnie aérienne et autres."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a351781851 = messageFormatterFn((function(  ) {
  return function(d) { return "Passeport"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1555852991 = messageFormatterFn((function(  ) {
  return function(d) { return "Enregistrez votre passeport pour réserver plus rapidement."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1802551252 = messageFormatterFn((function(  ) {
  return function(d) { return "Gestion des appareils"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a183076728 = messageFormatterFn((function(  ) {
  return function(d) { return "Vérifiez vos appareils connectés"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a2088429728 = messageFormatterFn((function(  ) {
  return function(d) { return "Se connecter pour accéder au compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a146333763 = messageFormatterFn((function(  ) {
  return function(d) { return "Créer un compte"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1184476446 = messageFormatterFn((function(  ) {
  return function(d) { return "Désolés, une erreur s’est produite de notre côté."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1912953225 = messageFormatterFn((function(  ) {
  return function(d) { return "Il semble que vous êtes hors ligne. Veuillez vérifier votre connexion Internet et réessayer."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1752039805 = messageFormatterFn((function(  ) {
  return function(d) { return "Réessayer"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b694782412 = messageFormatterFn((function(  ) {
  return function(d) { return "Chargement en cours..."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a671722201 = messageFormatterFn((function(  ) {
  return function(d) { return "1 nuit"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1632881953 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " nuits"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b336892211 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminé, 1 nuit sélectionnée. Sauvegardez les changements et fermez le calendrier."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.b1343064683 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminé, " + d["0"] + " nuits sélectionnées. Sauvegardez les changements et fermez le calendrier."; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1219827858 = messageFormatterFn((function(  ) {
  return function(d) { return "Date"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a518749307 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " résultats"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a1251567795 = messageFormatterFn((function(  ) {
  return function(d) { return "1 résultat"; }
})(), Globalize("fr-BE").pluralGenerator({}));
Globalize.a800372719 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b314173649 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1485372606 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1687140732 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b260032625 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1263297860 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1537689391 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b205891601 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a323602671 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b1726943998 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b978452593 = dateToPartsFormatterFn({"2":Globalize("fr-BE").numberFormatter({"raw":"00"}),"4":Globalize("fr-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b107610352 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"D","mon":"L","tue":"M","wed":"M","thu":"J","fri":"V","sat":"S"}}}});
Globalize.a1797613167 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"dimanche","mon":"lundi","tue":"mardi","wed":"mercredi","thu":"jeudi","fri":"vendredi","sat":"samedi"}}}});
Globalize.a544367727 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janvier","2":"février","3":"mars","4":"avril","5":"mai","6":"juin","7":"juillet","8":"août","9":"septembre","10":"octobre","11":"novembre","12":"décembre"}}}});
Globalize.a1144508113 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a860688418 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"}),"2":Globalize("fr-BE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1124719455 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"janv.","2":"févr.","3":"mars","4":"avr.","5":"mai","6":"juin","7":"juil.","8":"août","9":"sept.","10":"oct.","11":"nov.","12":"déc."}}}});
Globalize.a487203594 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janvier","2":"février","3":"mars","4":"avril","5":"mai","6":"juin","7":"juillet","8":"août","9":"septembre","10":"octobre","11":"novembre","12":"décembre"}}}});
Globalize.b19536661 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"janvier","2":"février","3":"mars","4":"avril","5":"mai","6":"juin","7":"juillet","8":"août","9":"septembre","10":"octobre","11":"novembre","12":"décembre"}}}});
Globalize.b139238187 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"janvier","2":"février","3":"mars","4":"avril","5":"mai","6":"juin","7":"juillet","8":"août","9":"septembre","10":"octobre","11":"novembre","12":"décembre"}}}});
Globalize.b138552994 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"janv.","2":"févr.","3":"mars","4":"avr.","5":"mai","6":"juin","7":"juil.","8":"août","9":"sept.","10":"oct.","11":"nov.","12":"déc."}}}});
Globalize.b262067169 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"dimanche","mon":"lundi","tue":"mardi","wed":"mercredi","thu":"jeudi","fri":"vendredi","sat":"samedi"}}},"months":{"M":{"3":{"1":"janv.","2":"févr.","3":"mars","4":"avr.","5":"mai","6":"juin","7":"juil.","8":"août","9":"sept.","10":"oct.","11":"nov.","12":"déc."}}}});
Globalize.a479815426 = dateToPartsFormatterFn({"1":Globalize("fr-BE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"dim.","mon":"lun.","tue":"mar.","wed":"mer.","thu":"jeu.","fri":"ven.","sat":"sam."}}},"months":{"M":{"3":{"1":"janv.","2":"févr.","3":"mars","4":"avr.","5":"mai","6":"juin","7":"juil.","8":"août","9":"sept.","10":"oct.","11":"nov.","12":"déc."}}}});
Globalize.a1179086470 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a64540102 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a329544601 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b792909357 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a118681126 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1216752229 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1916403142 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a172822150 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a702316422 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a87973209 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b599738842 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b258783719 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a961452614 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b291792826 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a1727791706 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"d"}));
Globalize.a469281337 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1552578024 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a865917345 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1164312268 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a239475564 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a240160757 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b879797720 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a858529177 = dateFormatterFn(Globalize("fr-BE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1501819083 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1678601845 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b459836408 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1582290366 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1732742869 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b2006133238 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b764502411 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1786883893 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1978589131 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b701407800 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1014322901 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1547351050 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^D/],["mon",/^L/],["tue",/^M/],["wed",/^M/],["thu",/^J/],["fri",/^V/],["sat",/^S/]]});
Globalize.a49883701 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^dimanche/],["wed",/^mercredi/],["fri",/^vendredi/],["sat",/^samedi/],["mon",/^lundi/],["tue",/^mardi/],["thu",/^jeudi/]]});
Globalize.b1203361739 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septembre/],["11",/^novembre/],["12",/^décembre/],["1",/^janvier/],["2",/^février/],["7",/^juillet/],["10",/^octobre/],["4",/^avril/],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.a170004683 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a624884328 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1443396775 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^janv\./],["2",/^févr\./],["7",/^juil\./],["9",/^sept\./],["4",/^avr\./],["10",/^oct\./],["11",/^nov\./],["12",/^déc\./],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.b1814988208 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septembre/],["11",/^novembre/],["12",/^décembre/],["1",/^janvier/],["2",/^février/],["7",/^juillet/],["10",/^octobre/],["4",/^avril/],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.a1626961509 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septembre/],["11",/^novembre/],["12",/^décembre/],["1",/^janvier/],["2",/^février/],["7",/^juillet/],["10",/^octobre/],["4",/^avril/],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.a1853537307 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septembre/],["11",/^novembre/],["12",/^décembre/],["1",/^janvier/],["2",/^février/],["7",/^juillet/],["10",/^octobre/],["4",/^avril/],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.a1854222500 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^janv\./],["2",/^févr\./],["7",/^juil\./],["9",/^sept\./],["4",/^avr\./],["10",/^oct\./],["11",/^nov\./],["12",/^déc\./],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.a1474709273 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^dimanche/],["wed",/^mercredi/],["fri",/^vendredi/],["sat",/^samedi/],["mon",/^lundi/],["tue",/^mardi/],["thu",/^jeudi/]],"gregorian/months/format/abbreviated":[["1",/^janv\./],["2",/^févr\./],["7",/^juil\./],["9",/^sept\./],["4",/^avr\./],["10",/^oct\./],["11",/^nov\./],["12",/^déc\./],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
Globalize.b1822376376 = dateParserFn(Globalize("fr-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^dim\./],["mon",/^lun\./],["tue",/^mar\./],["wed",/^mer\./],["thu",/^jeu\./],["fri",/^ven\./],["sat",/^sam\./]],"gregorian/months/format/abbreviated":[["1",/^janv\./],["2",/^févr\./],["7",/^juil\./],["9",/^sept\./],["4",/^avr\./],["10",/^oct\./],["11",/^nov\./],["12",/^déc\./],["3",/^mars/],["6",/^juin/],["8",/^août/],["5",/^mai/]]});
module.exports = Globalize;
